"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _generateNewId = _interopRequireDefault(require("../generateNewId.js"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _Condition = _interopRequireDefault(require("../Condition"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var aggregationOptions = [{
  value: 'all',
  label: 'All'
}, {
  value: 'any',
  label: 'Any'
}];
var Level = function Level(props) {
  var path = props.path,
    values = props.values,
    DataConnectorsPicker = props.DataConnectorsPicker,
    getDataConnectorMeta = props.getDataConnectorMeta;
  var level = path ? (0, _get2["default"])(values, path) : values;
  var prefix = path ? path + '.' : '';
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].aggregation
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(prefix, "aggregation"),
    component: _cccisdFormik.CccisdSelect,
    options: aggregationOptions,
    style: {
      width: 'auto'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, "of the following are true")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].conditions
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: "".concat(prefix, "conditions"),
    render: function render(arrayHelpers) {
      return /*#__PURE__*/_react["default"].createElement("div", null, level.conditions.length === 0 && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, "At least one condition is required"), level.conditions.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          style: _objectSpread({
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '0.8rem'
          }, !item.conditions && {
            alignItems: 'center'
          })
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"]["delete"],
          style: _objectSpread({}, item.conditions && {
            paddingTop: '0.5em'
          }),
          onClick: function onClick() {
            return arrayHelpers.remove(index);
          }
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            flexGrow: 1
          }
        }, item.conditions ? /*#__PURE__*/_react["default"].createElement(Level, _extends({}, props, {
          path: "".concat(prefix, "conditions[").concat(index, "]")
        })) : /*#__PURE__*/_react["default"].createElement(_Condition["default"], {
          path: "".concat(prefix, "conditions[").concat(index, "]"),
          condition: item,
          DataConnectorsPicker: DataConnectorsPicker,
          getDataConnectorMeta: getDataConnectorMeta
        })));
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: (0, _generateNewId["default"])(level.conditions),
            dataConnector: null,
            operator: '0',
            value: ''
          });
        }
      }, "Add condition"), ' ', /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: (0, _generateNewId["default"])(level.conditions),
            aggregation: 'all',
            conditions: [{
              id: 1,
              dataConnector: null,
              operator: '0',
              value: ''
            }]
          });
        }
      }, "Add condition set"));
    }
  })));
};
Level.propTypes = {
  path: _propTypes["default"].string,
  values: _propTypes["default"].object,
  DataConnectorsPicker: _propTypes["default"].func,
  getDataConnectorMeta: _propTypes["default"].func
};
var _default = exports["default"] = Level;